/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedWebhookReceiptsRouteImport } from './routes/_authenticated/webhook-receipts'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedRequestsRouteImport } from './routes/_authenticated/requests'
import { Route as AuthenticatedReconciliationRouteImport } from './routes/_authenticated/reconciliation'
import { Route as AuthenticatedOutcomesRouteImport } from './routes/_authenticated/outcomes'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedTenantsIndexRouteImport } from './routes/_authenticated/tenants/index'
import { Route as AuthenticatedTenantsTenantIdRouteImport } from './routes/_authenticated/tenants/$tenantId'
import { Route as AuthenticatedSchemaOutboundRouteImport } from './routes/_authenticated/schema/outbound'
import { Route as AuthenticatedSchemaInboundRouteImport } from './routes/_authenticated/schema/inbound'
import { Route as AuthenticatedSchemaCanonicalRouteImport } from './routes/_authenticated/schema/canonical'
import { Route as AuthenticatedPipelineSyncRouteImport } from './routes/_authenticated/pipeline/sync'
import { Route as AuthenticatedPipelineSchedulerRouteImport } from './routes/_authenticated/pipeline/scheduler'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWebhookReceiptsRoute =
  AuthenticatedWebhookReceiptsRouteImport.update({
    id: '/webhook-receipts',
    path: '/webhook-receipts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRequestsRoute = AuthenticatedRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReconciliationRoute =
  AuthenticatedReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOutcomesRoute = AuthenticatedOutcomesRouteImport.update({
  id: '/outcomes',
  path: '/outcomes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTenantsIndexRoute =
  AuthenticatedTenantsIndexRouteImport.update({
    id: '/tenants/',
    path: '/tenants/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTenantsTenantIdRoute =
  AuthenticatedTenantsTenantIdRouteImport.update({
    id: '/tenants/$tenantId',
    path: '/tenants/$tenantId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchemaOutboundRoute =
  AuthenticatedSchemaOutboundRouteImport.update({
    id: '/schema/outbound',
    path: '/schema/outbound',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchemaInboundRoute =
  AuthenticatedSchemaInboundRouteImport.update({
    id: '/schema/inbound',
    path: '/schema/inbound',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSchemaCanonicalRoute =
  AuthenticatedSchemaCanonicalRouteImport.update({
    id: '/schema/canonical',
    path: '/schema/canonical',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineSyncRoute =
  AuthenticatedPipelineSyncRouteImport.update({
    id: '/pipeline/sync',
    path: '/pipeline/sync',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineSchedulerRoute =
  AuthenticatedPipelineSchedulerRouteImport.update({
    id: '/pipeline/scheduler',
    path: '/pipeline/scheduler',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/outcomes': typeof AuthenticatedOutcomesRoute
  '/reconciliation': typeof AuthenticatedReconciliationRoute
  '/requests': typeof AuthenticatedRequestsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/webhook-receipts': typeof AuthenticatedWebhookReceiptsRoute
  '/pipeline/scheduler': typeof AuthenticatedPipelineSchedulerRoute
  '/pipeline/sync': typeof AuthenticatedPipelineSyncRoute
  '/schema/canonical': typeof AuthenticatedSchemaCanonicalRoute
  '/schema/inbound': typeof AuthenticatedSchemaInboundRoute
  '/schema/outbound': typeof AuthenticatedSchemaOutboundRoute
  '/tenants/$tenantId': typeof AuthenticatedTenantsTenantIdRoute
  '/tenants/': typeof AuthenticatedTenantsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/outcomes': typeof AuthenticatedOutcomesRoute
  '/reconciliation': typeof AuthenticatedReconciliationRoute
  '/requests': typeof AuthenticatedRequestsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/webhook-receipts': typeof AuthenticatedWebhookReceiptsRoute
  '/': typeof AuthenticatedIndexRoute
  '/pipeline/scheduler': typeof AuthenticatedPipelineSchedulerRoute
  '/pipeline/sync': typeof AuthenticatedPipelineSyncRoute
  '/schema/canonical': typeof AuthenticatedSchemaCanonicalRoute
  '/schema/inbound': typeof AuthenticatedSchemaInboundRoute
  '/schema/outbound': typeof AuthenticatedSchemaOutboundRoute
  '/tenants/$tenantId': typeof AuthenticatedTenantsTenantIdRoute
  '/tenants': typeof AuthenticatedTenantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/outcomes': typeof AuthenticatedOutcomesRoute
  '/_authenticated/reconciliation': typeof AuthenticatedReconciliationRoute
  '/_authenticated/requests': typeof AuthenticatedRequestsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/webhook-receipts': typeof AuthenticatedWebhookReceiptsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/pipeline/scheduler': typeof AuthenticatedPipelineSchedulerRoute
  '/_authenticated/pipeline/sync': typeof AuthenticatedPipelineSyncRoute
  '/_authenticated/schema/canonical': typeof AuthenticatedSchemaCanonicalRoute
  '/_authenticated/schema/inbound': typeof AuthenticatedSchemaInboundRoute
  '/_authenticated/schema/outbound': typeof AuthenticatedSchemaOutboundRoute
  '/_authenticated/tenants/$tenantId': typeof AuthenticatedTenantsTenantIdRoute
  '/_authenticated/tenants/': typeof AuthenticatedTenantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/dashboard'
    | '/outcomes'
    | '/reconciliation'
    | '/requests'
    | '/settings'
    | '/webhook-receipts'
    | '/pipeline/scheduler'
    | '/pipeline/sync'
    | '/schema/canonical'
    | '/schema/inbound'
    | '/schema/outbound'
    | '/tenants/$tenantId'
    | '/tenants/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/analytics'
    | '/dashboard'
    | '/outcomes'
    | '/reconciliation'
    | '/requests'
    | '/settings'
    | '/webhook-receipts'
    | '/'
    | '/pipeline/scheduler'
    | '/pipeline/sync'
    | '/schema/canonical'
    | '/schema/inbound'
    | '/schema/outbound'
    | '/tenants/$tenantId'
    | '/tenants'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/analytics'
    | '/_authenticated/dashboard'
    | '/_authenticated/outcomes'
    | '/_authenticated/reconciliation'
    | '/_authenticated/requests'
    | '/_authenticated/settings'
    | '/_authenticated/webhook-receipts'
    | '/_authenticated/'
    | '/_authenticated/pipeline/scheduler'
    | '/_authenticated/pipeline/sync'
    | '/_authenticated/schema/canonical'
    | '/_authenticated/schema/inbound'
    | '/_authenticated/schema/outbound'
    | '/_authenticated/tenants/$tenantId'
    | '/_authenticated/tenants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/webhook-receipts': {
      id: '/_authenticated/webhook-receipts'
      path: '/webhook-receipts'
      fullPath: '/webhook-receipts'
      preLoaderRoute: typeof AuthenticatedWebhookReceiptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests': {
      id: '/_authenticated/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AuthenticatedRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reconciliation': {
      id: '/_authenticated/reconciliation'
      path: '/reconciliation'
      fullPath: '/reconciliation'
      preLoaderRoute: typeof AuthenticatedReconciliationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/outcomes': {
      id: '/_authenticated/outcomes'
      path: '/outcomes'
      fullPath: '/outcomes'
      preLoaderRoute: typeof AuthenticatedOutcomesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/': {
      id: '/_authenticated/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof AuthenticatedTenantsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tenants/$tenantId': {
      id: '/_authenticated/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/tenants/$tenantId'
      preLoaderRoute: typeof AuthenticatedTenantsTenantIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schema/outbound': {
      id: '/_authenticated/schema/outbound'
      path: '/schema/outbound'
      fullPath: '/schema/outbound'
      preLoaderRoute: typeof AuthenticatedSchemaOutboundRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schema/inbound': {
      id: '/_authenticated/schema/inbound'
      path: '/schema/inbound'
      fullPath: '/schema/inbound'
      preLoaderRoute: typeof AuthenticatedSchemaInboundRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schema/canonical': {
      id: '/_authenticated/schema/canonical'
      path: '/schema/canonical'
      fullPath: '/schema/canonical'
      preLoaderRoute: typeof AuthenticatedSchemaCanonicalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/sync': {
      id: '/_authenticated/pipeline/sync'
      path: '/pipeline/sync'
      fullPath: '/pipeline/sync'
      preLoaderRoute: typeof AuthenticatedPipelineSyncRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/scheduler': {
      id: '/_authenticated/pipeline/scheduler'
      path: '/pipeline/scheduler'
      fullPath: '/pipeline/scheduler'
      preLoaderRoute: typeof AuthenticatedPipelineSchedulerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedOutcomesRoute: typeof AuthenticatedOutcomesRoute
  AuthenticatedReconciliationRoute: typeof AuthenticatedReconciliationRoute
  AuthenticatedRequestsRoute: typeof AuthenticatedRequestsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedWebhookReceiptsRoute: typeof AuthenticatedWebhookReceiptsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedPipelineSchedulerRoute: typeof AuthenticatedPipelineSchedulerRoute
  AuthenticatedPipelineSyncRoute: typeof AuthenticatedPipelineSyncRoute
  AuthenticatedSchemaCanonicalRoute: typeof AuthenticatedSchemaCanonicalRoute
  AuthenticatedSchemaInboundRoute: typeof AuthenticatedSchemaInboundRoute
  AuthenticatedSchemaOutboundRoute: typeof AuthenticatedSchemaOutboundRoute
  AuthenticatedTenantsTenantIdRoute: typeof AuthenticatedTenantsTenantIdRoute
  AuthenticatedTenantsIndexRoute: typeof AuthenticatedTenantsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedOutcomesRoute: AuthenticatedOutcomesRoute,
  AuthenticatedReconciliationRoute: AuthenticatedReconciliationRoute,
  AuthenticatedRequestsRoute: AuthenticatedRequestsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedWebhookReceiptsRoute: AuthenticatedWebhookReceiptsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedPipelineSchedulerRoute: AuthenticatedPipelineSchedulerRoute,
  AuthenticatedPipelineSyncRoute: AuthenticatedPipelineSyncRoute,
  AuthenticatedSchemaCanonicalRoute: AuthenticatedSchemaCanonicalRoute,
  AuthenticatedSchemaInboundRoute: AuthenticatedSchemaInboundRoute,
  AuthenticatedSchemaOutboundRoute: AuthenticatedSchemaOutboundRoute,
  AuthenticatedTenantsTenantIdRoute: AuthenticatedTenantsTenantIdRoute,
  AuthenticatedTenantsIndexRoute: AuthenticatedTenantsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
